<template>
	<div>
		<div class="card mb-4">
            <div class="card-header">
		    	<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Informações</strong>
		            </div>
		            <div class="text-muted fs-19">
		            	<button 
							class="btn btn-success mr-1"
							@click="addTag()">
							<i class="fas fa-tag"></i>
							Adicionar Tag
						</button>
		            </div>
			    </div>
		    </div>
		    <div class="card-body">
		    	<div class="container-fluid">
		    		<div class="row">
		    			<div class="col-md-6">
		    				<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Pedido</strong>
				            </div>
		    				<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between teste">
									<div>
										<strong>#</strong>
									</div>
									<div>
										{{ dados.id }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Cliente</strong>
									</div>
									<div>
										{{ dados.cliente || '-' }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Estágio</strong>
									</div>
									<div 
										class="fs-19" 
										v-html="dados.estagio_badge"></div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Data</strong>
									</div>
									<div>
										{{ dados.data_br }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Prazo</strong>
									</div>
									<div 
										class="fs-19" 
										v-html="dados.prazo_badge"></div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Total itens</strong>
									</div>
									<div>
										{{ dados.total_itens }}
									</div>
								</li>
							</ul>
		    			</div>
		    			<div class="col-md-6">
		    				<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Valores</strong>
				            </div>
		    				<ul class="list-group">
		    					<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Valor</strong>
									</div>
									<div class="text-success">
										{{ formatarValor(dados.valor) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Desconto</strong>
									</div>
									<div class="text-danger">
										{{ formatarValor(dados.desconto) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Valor Total</strong>
									</div>
									<div class="text-success">
										{{ formatarValor(dados.valor_total) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Valor Pago</strong>
									</div>
									<div class="text-success">
										{{ formatarValor(dados.valor_pago) }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Custo de Produção</strong>
									</div>
									<div class="text-danger">
										{{ getCustoProducaoFormatado() }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Percentual de lucro</strong>
									</div>
									<div>
										{{ getPercentualLucro() }}
									</div>
								</li>
		    				</ul>
		    			</div>
		    		</div>

		    		<div class="row mt-4" v-if="dados.descricao">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Descrição</strong>
				            </div>
					        <div class="card">
  								<div class="card-body" v-html="dados.descricao"></div>
							</div>
					    </div>
					</div>
					<div class="row mt-4" v-if="tags.length > 0">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Tags</strong>
				            </div>
					        <ul class="list-group">
		    					<li class="list-group-item d-flex">
		    						<span 
		    							v-for="tag in tags" 
		    							:class="'badge pointer badge-pill d-flex badge-'+tag.cor+' px-3 py-2 mr-2'">
		    							<div 
		    								v-html="tag.icone" 
		    								class="mr-2" 
		    								v-if="tag.icone">
		    							</div>
		    							<div>{{ tag.nome }}</div>
		    							<div 
		    								class="close-tag" 
		    								@click="removeTag(tag)">
		    								&times;
		    							</div>
		    						</span>
		    					</li>
		    				</ul>
					    </div>
					</div>
					<div class="row mt-4" v-if="dados.estagio_id == 2">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Progresso</strong>
				            </div>
					        <ul class="list-group">
		    					<li class="list-group-item">
									<div class="progress">
										<div 
											class="progress-bar" 
											role="progressbar" 
											:style="'width: '+dados.progresso+'%;'" 
											:aria-valuenow="dados.progresso" 
											aria-valuemin="0" 
											aria-valuemax="100">
											{{ dados.progresso }}%
										</div>
									</div>
								</li>
							</ul>
					    </div>
					</div>
				</div>
		    </div>
		</div>
		<pedido-tags-create
			@reload="reload">
		</pedido-tags-create>
	</div>
</template>

<script>
	export default {
		props: ['dados'],
		data(){
			return {
				tags: [],
			}
		},
		updated(){
			this.tags = this.dados.tags;
		},
		methods: {
			getCustoProducao(){
				let custo = 0;
				for(let item of this.dados.itens){
					if(item.custo_producao){
						custo += item.custo_producao;
					}
				}
				return custo;
			},
			getCustoProducaoFormatado(){
				return this.getCustoProducao().toLocaleString('pt-BR', {
					style: 'currency',
					currency: 'BRL'
				});
			},
			getPercentualLucro(){
				let custo_producao = this.getCustoProducao();
				this.percentual_lucro = null;
				if (custo_producao > 0) {
					this.percentual_lucro = (
						(this.dados.valor_total - custo_producao)
						/ custo_producao
					) * 100;
				}
				return this.formatarPercentual(this.percentual_lucro);
			},
			formatarPercentual(percentual) {
				if (!percentual) {
					return null;
				}
				return percentual.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).replace(/\./g, '') + '%';
			},
			formatarValor(valor=null) {
				if(valor === null || valor === undefined){
					valor = 0;
				}
				valor = parseFloat(valor);
				return valor.toLocaleString('pt-BR', {
					style: 'currency',
					currency: 'BRL'
				});
			},
			addTag(){
				$('#create_pedido_tag').modal('show');
			},
			removeTag(tag){
				axios.delete(this.$url+'/api/adm/pedido-tags/destroy/'+tag.id)
                    .then(response => {
                      this.reload()
                      this.$bshMessage.show(response.data.message, response.data.type)
                    })
                    .catch(error => (this.$bshMessage.show(response.data.message, response.data.type)));
			},
			reload(){
				this.$emit('reload')
			}
		}
	}
</script>

<style scoped>
	.pointer {
		cursor: pointer;
	}
	.close-tag {
		border-radius: 50px;
		background-color: red;
		padding-left: 3px;
		padding-right: 3px;
		padding-top: 1px;
		padding-bottom: 1px;
		margin-left: 10px;
		position: relative;
		display: none;
	}
	.close-tag:hover {
		font-size: 15px;
	}
	.badge-pill:hover .close-tag {
		display: block;
	}
</style>
